import React, { useEffect, useState } from "react";
import { Table, Tag, message } from "antd";
import firebase from "firebase/compat/app";
import moment from "moment";
import _ from "lodash";
import Certificates from "../../Settings/ApiAccess/Certificates";

// Comptes de service (Accès API) d'une société, en lecture seule pour le staff Solidoc.
// Ils sont gérés par les administrateurs du client ; le staff ne voit jamais les clés, mais voit
// les certificats clients, publics, pour le support des LRE (décision 02/10/2026).
export default function ServiceAccounts({ companyId }) {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    const db = firebase.firestore();
    setLoading(true);
    db.collection("service_accounts")
      .where("company", "==", db.collection("companies").doc(companyId))
      .get()
      .then((snap) => {
        setAccounts(
          _.sortBy(
            snap.docs.map((doc) => ({ id: doc.id, key: doc.id, ...doc.data() })),
            (account) => (account.name || "").toLowerCase()
          )
        );
      })
      .catch((e) => {
        console.error("Error fetching service accounts:", e);
        message.error("Erreur lors du chargement des comptes de service");
      })
      .finally(() => setLoading(false));
  }, [companyId]);

  if (!companyId) return null;

  const columns = [
    { title: "Nom", dataIndex: "name", key: "name" },
    {
      title: "Statut",
      key: "status",
      width: 110,
      render: (_value, record) =>
        record.is_active ? <Tag color="green">Actif</Tag> : <Tag>Désactivé</Tag>,
    },
    {
      title: "E-mail de notification",
      dataIndex: "notification_email",
      key: "notification_email",
      render: (value) => value || "—",
    },
    {
      title: "Créé le",
      key: "created_at",
      width: 110,
      render: (_value, record) =>
        record.created_at ? moment(record.created_at.toDate()).format("DD/MM/YYYY") : "—",
    },
  ];

  return (
    <>
      <div style={{ fontWeight: 500, marginBottom: 12 }}>
        Comptes de service (gérés par les administrateurs du client ; clés non visibles, certificats
        en dépliant la ligne)
      </div>
      <Table
        dataSource={accounts}
        columns={columns}
        loading={loading}
        pagination={false}
        size="small"
        locale={{ emptyText: "Aucun compte de service" }}
        expandable={{
          expandedRowRender: (record) => (
            <Certificates account={record} companyId={companyId} readOnly />
          ),
        }}
      />
    </>
  );
}
